//Константы для отображения графа
export default {
    load:{
        data: "Loading data ...",
        generateVisual: "Generating visualization ...",
        faledLoadOntology: "Failed to load ontology",
        okLoadOntology: "Successfully loaded ontology",
        warnLoadOntology: "Loaded ontology with warnings",
        detail: "Details"
    },
    statistic : {
        classes: "Classes",
        subclasses: "Subclasses",
        types: "Types",
        objectProperties: "ObjectProperty",
        dataProperties: "DataProperty",
        individuals: "Individual",
        nodeCount: "Nodes",
        nodeOf: "of",
        nodeDetails: "incl.",
        edgeCount: "Edges",
        edgeOf: "of",
        edgeDetails: "incl.",
        nodeIncluding: "including",
        equivalents: "equivalents",
        external: "external",
        externalElement: "external link"
    },
    detail: {
        noSelect: "Select an element in the graph",
        lable: "Label",
        type: "Type",
        dataType: "Datatype",
        characteristics: "Characteristics",
        version: "Version",
        authors: "Author(s)",
        language: "Language"
    },
    options: {
        title: "Options" 
    },
    modes: {
        title: "Modes" 
    },
    search: {
        placeholder: "Search",
        noFind: "Nothing to locate, enter search term.",
    },
    legend: {
        title: "Legend",
        detail: "Detailed information about the graphic primitives used is given in the article",
        noLegend: "The graph nodes represent the subjects and objects of triplets, the edges represent the predicates."
    },
    ontology: {
        title: "Ontology",
        dcTitle: "Title",
        dcTitleHint: "Ontology name from dc:title",
        version: "Version",
        versionHint: "Ontology version number from owl:versionInfo",
        creator: "Authors",
        creatorHint: "Ontology authors from dc:creator"
    },
    description: {
        title: "Description",
    },
    prefix: {
        title: "Prefix"
    },
    metadata: {
        title: "Metadata"
    },
    sidebar: {
        noTitle: "No title available",
        noDescription: "No description available",
        notGiven: "not given",
        noAnnatations: "No annotations available"
    },
    warning: {
        filterHint: "Collapsing filter activated.<br>" +
                "The number of visualized elements has been automatically reduced.<br>" +
                "Use the degree of collapsing slider and/or checkbox in the <em>filter</em> menu to adjust the visualization.<br><br>"+
                "<em>Note:</em> A performance decrease could be experienced with a growing amount of visual elements in the graph."
    },
    loading_data: "Loading data for the graph...",
    section_statistic: "Statistics",
    section_details: "Element details",
    section_legend: "Legend",
      process: {    
	  START:  "Loading data for the graph...",
	  START_CONTENT:  "Retrieving data for graph...", //1000;
	  CONTENT_RECEIVED: "Content (graph data) received...", // 1001;
	  START_CACHE: "Retrieving data from cache...", //1002;
	  FINISH_CACHE: "Data received from cache", //1003;	
	  CONVERT_PREPARE: "Preparing data for conversion to graph...", // 1010;
	  CONVERT: "Converting data to graph...", // 1011;
	  ERROR: "Error during conversion!", // 1013;
	  FINISH:  "Data received. Preparation for graph visualization has begun..."
  },
  filter: {
    title: "Filter",
    topic: "Filters",
    allLink: "All links",
    edges: "Connections",
    hideLinks: "Hide links"
  }
};